<template>
  <form>
    <Modal
      :cancelFunction="closeModal"
      :isSaving="isSaving"
      :okFunction="addTypographyScheme"
      :modalStyles="{
        width: '400px',
        // height: '740px',
      }"
      noScrollbar
      :disabled="typographyName.length < 3"
      title="Add Brand Typography"
    >
      <template v-slot:body>
        <div class="group-body">
          <div class="form-group">
            <label for="typographyName" class="label">Custom Name </label>
            <input
              class="form-control"
              type="text"
              id="typographyName"
              placeholder="Name of Typography"
              v-model="typographyName"
              required
            />
          </div>
          <div class="form-group">
            <div class="label-header">
              <label class="label">Font</label>
              <div class="import-link" @click.prevent="showFontsModal = true">
                <i class="material-icons-outlined align-middle button">upload</i>
                Import fonts
              </div>
            </div>
            <div class="font-selector-container">
              <FontSelector
                :value="fontFamily"
                :fonts="fonts"
                :max-height="300"
                noAutoScroll
                noBrandFonts
                @update:value="fontFamily = $event"
              />
            </div>
          </div>

          <!-- <div class="form-group">
            <div class="form-row">
              <div class="color-picker-container">
                <label for="fontColor" class="label">Font color</label>
                <ColorPicker v-model="fontColor" />
              </div>
            </div>
          </div>

          <div class="form-group">
            <div class="form-row">
              <div class="size-container">
                <label class="label">Text Size</label>
                <NumberInput v-model="fontSize" />
              </div>
              <div class="fontstyle-container">
                <label for="label">Font style </label>
                <select class="select-box" id="style" v-model="fontStyle">
                  <option
                    class="select-options"
                    v-for="style in styles"
                    :key="style.label"
                    :value="style.value"
                  >
                    {{ style.label }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="form-group">
            <div class="form-row">
              <div class="line-height-container">
                <label for="lineHeight">
                  <span class="text">Line height</span>
                </label>
                <NumberInput v-model="lineHeight" />
              </div>
              <div class="letter-spacing-container">
                <label for="letterSpacing">
                  <span class="text">Letter spacing</span>
                </label>
                <NumberInput v-model="letterSpacing" />
              </div>
            </div>
          </div>
          <div class="form-group">
            <label class="text">Alignment</label>
            <div class="alignment-container">
              <div v-for="alignment in alignments" :key="alignment.label">
                <button
                  :class="{ 'selected-alignment': alignment.value === fontAlignment }"
                  class="align-button"
                  :value="alignment.value"
                  :id="alignment.label"
                  @click="setAlignment(alignment.value)"
                >
                  <i class="material-icons-outlined align-middle">
                    {{ `format_align_${alignment.value}` }}</i
                  >
                </button>
              </div>
            </div>
          </div> -->
        </div>
      </template>
    </Modal>
    <FontsModal v-if="showFontsModal" @closeModal="showFontsModal = false" />
  </form>
</template>

<script>
  import Modal from '@/components/common/Modal.vue';
  import { apiPostOrganisationScheme, apiUserPostOrganisationScheme } from '@/api/organisation';
  import FontSelector from '@/components/common/fontSelector/FontSelector.vue';
  import FontsModal from '@/components/common/FontsModal.vue';
  import { getFontsApi } from '@/api/fonts';
  import NumberInput from '@/components/common/toolbar/NumberInput.vue';
  import ColorPicker from '@/components/ColorPicker.vue';

  export default {
    name: 'AddTypographyModal',

    components: { Modal, FontsModal, FontSelector, NumberInput, ColorPicker },

    data() {
      return {
        typographyName: '',
        fontFamily: 'Default',
        fontSize: 12,
        fontColor: '#000000',
        lineHeight: 1,
        letterSpacing: 1,
        fontStyle: 'normal',
        fontAlignment: 'left',
        isSaving: false,
        showFontsModal: false,
        fonts: [],
        styles: [
          { value: 'normal', label: 'Normal' },
          { value: 'italic', label: 'Italic' },
        ],
        alignments: [
          { value: 'left', label: 'Left' },
          { value: 'center', label: 'Center' },
          { value: 'right', label: 'Right' },
        ],
        showDropdown: false,
      };
    },

    computed: {
      organisationIdParam() {
        return this.$route.params.organisation_id;
      },
      isAdmin() {
        return this.$store.getters.isAdministrator;
      },
    },

    mounted() {
      this.fetchFonts();
    },

    methods: {
      async addTypographyScheme() {
        this.isSaving = true;

        try {
          const newScheme = {
            type: 'typography',
            name: this.typographyName,
            config: {
              'font-family': this.fontFamily,
              'font-size': this.fontSize,
              'font-color': this.fontColor,
              'line-height': this.lineHeight,
              'letter-spacing': this.letterSpacing,
              'font-style': this.fontStyle,
              'text-alignment': this.fontAlignment,
            },
          };
          let response;

          if (this.isAdmin) {
            let orgID = this.organisationIdParam;
            response = await apiPostOrganisationScheme(orgID, newScheme);
          } else {
            response = await apiUserPostOrganisationScheme(newScheme);
          }
          this.$toasted.global.general_success({
            message: 'Typography scheme added successfully',
          });
          this.$emit('schemeAdded', response.data);
          this.closeModal();
        } catch (error) {
          this.$toasted.global.general_error({
            message:
              error?.response?.data?.message ??
              error?.data?.message ??
              'Error creating typography scheme',
          });
        } finally {
          this.isSaving = false;
        }
      },
      async fetchFonts() {
        try {
          const response = await getFontsApi();
          this.fonts = response.data;
        } catch (error) {
          this.$toasted.global.general_error({
            message:
              error?.response?.data?.message ?? error?.data?.message ?? 'Failed to fetch fonts.',
          });
        }
      },
      toggleDropdown() {
        this.showDropdown = !this.showDropdown;
      },
      closeModal() {
        this.$emit('close');
      },
      setAlignment(selectedAlignment) {
        this.fontAlignment = selectedAlignment;
      },
    },
  };
</script>

<style scoped lang="scss">
  .group-body {
    display: grid;
    row-gap: 24px;
    column-gap: 16px;

    .form-group {
      width: 100%;
      margin-bottom: 0px;
      display: flex;
      flex-direction: column;
      margin-bottom: 0;
      gap: 8px;
    }

    label {
      width: 100%;
      font-weight: 500;
      font-size: 14px;
      line-height: 24px;
      margin-bottom: 0;
    }

    input.form-control {
      width: 100%;
      padding: 6px 16px;
      height: auto;
      border: 1px solid #e8e8e8;
      border-radius: 8px;
      font-size: 16px;
      line-height: 24px;
      color: #151515;

      &:focus {
        box-shadow: none;
        border-color: #696969;
      }
    }
  }
  .form-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    margin: 0px;
  }

  .form-second-row {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 10px;
  }

  .label-header {
    display: grid;
    grid-template-columns: 1fr 1fr;
    justify-content: space-between;
  }

  .label {
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    margin-bottom: 0;
  }

  .import-link {
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0%;
    color: #151515;
    cursor: pointer;
    display: flex;
    justify-content: flex-end;
  }

  .open-dropdown-container {
    width: 100%;
    display: flex;
    align-items: end;
    justify-content: center;
    flex-direction: column;
    position: relative;
  }
  .dropdown-button {
    background-color: #fff;
    border: none;
    cursor: pointer;
    font-size: 24x;
    color: #212529;
  }

  .dropdown-active {
    color: $primaryRed;
  }

  .dropdown-button:hover {
    color: $primaryRed;
  }

  .fontstyle-container {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-between;
  }

  .select-box {
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    width: 100%;
    padding: 6px 4px;
    font-size: 16px;
    color: #151515;
    height: auto;
    background-color: #fff;
  }

  .alignment-container {
    display: flex;
    gap: 14px;
    margin-top: 8px;
  }

  .align-button {
    background-color: #fff;
    border: none;
    cursor: pointer;
    font-size: 24x;
    padding: 0px;
    padding: 6px;
    color: #6a6b6a;
    border-radius: 5px;
    border: solid 1px transparent;
  }
  .align-button:hover {
    border: solid 1px #f5f5f5;
    border-radius: 5px;
    background: #f5f5f5;
    color: #000;
  }

  .selected-alignment {
    border: solid 1px #f5f5f5;
    border-radius: 5px;
    background: #f5f5f5;
    color: #000;
  }

  .font-selector-container {
    margin-left: -1px;
  }
</style>
